export default "__VITE_ASSET__Un0Z53lp__"